import {json,postBiz,rows} from '../core/coreapi';

import {
  ActivityCandidate,
  ActivityPlanningWorkbenchModel,
  ActivityTemplate,
  BudgetLineRow,
  IndicatorCandidate,
  KpiPlanRow,
} from './activityplanning.models';

import {
  normalizeActivityPlanningWorkbench,
  normalizeIndicatorCandidate,
} from './activityplanning.normalizers';

export const fetchGlobalObjectiveCombo=async(axc='')=>
  rows(
    await postBiz({
      s:'globalobjective',
      a:'combo',
      axc:axc||null,
    }),
  );

export const fetchSpecificObjectiveCombo=async(
  axc='',
  ogc='',
)=>
  rows(
    await postBiz({
      s:'specificobjective',
      a:'combo',
      axc:axc||null,
      ogc:ogc||null,
    }),
  );

export const fetchActivityPlanningWorkbench=async(
  planningcycleid:number,
):Promise<ActivityPlanningWorkbenchModel>=>{
  const response=await postBiz({
    s:'activityplanning',
    a:'workbench',
    pci:planningcycleid,
  });

  return normalizeActivityPlanningWorkbench(json(response));
};

export const setPlanningCostCenter=async(
  planningcycleid:number,
  costcenterid:number,
  stamp:string,
)=>json(
  await postBiz({
    s:'bieprofile',
    a:'costcenterset',
    pci:planningcycleid,
    cci:costcenterid,
    stp:stamp,
  }),
);

export const fetchIndicatorCandidates=async(
  planningcycleid:number,
  search='',
):Promise<IndicatorCandidate[]>=>{
  const response=await postBiz({
    s:'activityplanning',
    a:'indicatorcombo',
    pci:planningcycleid,
    sch:search||null,
  });

  return rows(response).map(normalizeIndicatorCandidate);
};

export const addIndicator=async(payload:{
  kpiid:number;
  planningcycleid:number;
  baselinevalue:number;
  targetvalue:number;
  thresholdmin?:number|null;
  thresholdmax?:number|null;
  description?:string;
})=>json(
  await postBiz({
    s:'activityplanning',
    a:'indicatoradd',

    kpi:payload.kpiid,
    pci:payload.planningcycleid,

    bsv:payload.baselinevalue,
    tgt:payload.targetvalue,
    thn:payload.thresholdmin??null,
    thx:payload.thresholdmax??null,
    dsc:payload.description??'',
  }),
);

export const saveIndicators=async(
  records:KpiPlanRow[],
)=>json(
  await postBiz({
    s:'activityplanning',
    a:'indicatorsave',
    rcd:records.filter(
      record=>
        record.__dirty
        ||record._state==='dirty'
        ||record._state==='deleted',
    ),
  }),
);

export const fetchActivityCandidates=async(
  kpiid:number,
  planningcycleid:number,
  costcentercode:string,
):Promise<ActivityCandidate[]> =>
  rows(
    await postBiz({
      s:'activityplanning',
      a:'activitycombo',
      kpi:kpiid,
      pci:planningcycleid,
      ccc:costcentercode,
    }),
  );

export const addActivity=async(payload:{
  kpiplanid:number;
  activityid:number;
  planningcycleid:number;
  weight:number;
  drivervalue?:number;
  targetvalue?:number;
  description?:string;
})=>json(
  await postBiz({
    s:'activityplanning',
    a:'activityadd',
    pci: payload.planningcycleid,
    kpi:payload.kpiplanid,
    aci:payload.activityid,
    wgt:payload.weight,
    dva:payload.drivervalue??0,
    tva:payload.targetvalue??0,
    dsc:payload.description??'',
  }),
);

export const fetchBudgetLines=async(
  taskplanid:number,
):Promise<BudgetLineRow[]>=>{
  const response=await postBiz({
    s:'activityplanning',
    a:'budgetlines',
    tpi:taskplanid,
    rid:taskplanid,
  });

  return rows(response).map((row:any,index:number)=>({
    id:
      row.id
      ??row.rid
      ??row.budgetlineid
      ??`budget-${taskplanid}-${index}`,

    rid:row.rid??row.budgetlineid??null,
    budgetlineid:row.budgetlineid??row.rid??null,

    taskplanid,
    taskid:row.taskid??null,

    accountid:row.accountid??null,
    accountcode:String(row.accountcode??row.acc??''),
    accountname:String(row.accountname??''),

    description:String(row.description??row.dsc??''),
    quantity:Number(row.quantity??row.qty??0),
    unitprice:Number(row.unitprice??row.upr??0),
    amount:Number(row.amount??row.amt??0),
    remarks:String(row.remarks??row.rmk??''),

    stamp:String(row.stamp??row.stp??''),
    status:Number(row.status??row.sts??1),

    _state:'clean',
    raw:row,
  }));
};

export const saveBudgetLines=async(
  taskplanid:number,
  records:any[],
)=>json(
  await postBiz({
    s:'activityplanning',
    a:'budgetsave',
    tpi:taskplanid,
    rid:taskplanid,
    rcd:records,
  }),
);

export const fetchTemplates=async():Promise<ActivityTemplate[]>=>
  rows(
    await postBiz({
      s:'activityplanning',
      a:'templates',
    }),
  );

export const applyTemplate=async(
  activityplanid:number,
  templatecode:string,
)=>json(
  await postBiz({
    s:'activityplanning',
    a:'templateapply',
    api:activityplanid,
    rid:activityplanid,
    tpc:templatecode,
  }),
);

export const validateActivityPlanning=async(
  planningcycleid:number,
)=>json(
  await postBiz({
    s:'activityplanning',
    a:'validate',
    pci:planningcycleid,
  }),
);
